import React from 'react';
import { useTranslation } from 'react-i18next';
import { useStyles } from './styles';

const HelpCenter: React.FC = () => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <div className={classes.container}>
      <div className={classes.iframeContainer}>
        <iframe
          title={t('screens:help.title')}
          src={t('screens:help.source')}
          className={classes.iframe}
        />
      </div>
    </div>
  );
};

export default HelpCenter;
